import match from 'mime-match';
/**
 * @class MediaType
 * @since 1.0.0
 */
export class MediaType {
    /**
     * @method match
     * @since 1.0.0
     */
    static match(mime, types) {
        return match(mime, types);
    }
    /**
     * @method isImage
     * @since 1.0.0
     */
    static isImage(mime) {
        switch (mime) {
            case 'image/gif':
            case 'image/png':
            case 'image/jpeg':
            case 'image/svg+xml':
            case 'image/webp':
                return true;
        }
        return false;
    }
    /**
     * @method isVideo
     * @since 1.0.0
     */
    static isVideo(mime) {
        switch (mime) {
            case 'video/ogg':
            case 'video/mp4':
                return true;
        }
        return false;
    }
    /**
     * @method isAudio
     * @since 1.0.0
     */
    static isAudio(mime) {
        switch (mime) {
            case 'audio/ogg':
            case 'audio/mpeg':
                return true;
        }
        return false;
    }
    /**
     * @method isFile
     * @since 1.0.0
     */
    static isFile(mime) {
        switch (mime) {
            case 'application/pdf':
                return true;
        }
        return false;
    }
    /**
     * @method getKind
     * @since 1.0.0
     */
    static getKind(mime) {
        if (this.isImage(mime))
            return MediaKind.Image;
        if (this.isVideo(mime))
            return MediaKind.Video;
        if (this.isAudio(mime))
            return MediaKind.Audio;
        if (this.isFile(mime))
            return MediaKind.Pdf;
        return null;
    }
}
/**
 * @property labels
 * @since 1.0.0
 */
MediaType.labels = {
    'image/gif': 'GIF Image',
    'image/png': 'PNG Image',
    'image/jpeg': 'JPEG Image',
    'image/webp': 'WebP Image',
    'image/svg+xml': 'SVG Image',
    'video/ogg': 'OGG Video',
    'video/mp4': 'MP4 Video',
    'audio/ogg': 'OGG Audio',
    'audio/mpeg': 'MP3 Audio',
    'application/pdf': 'PDF File'
};
/**
 * @property images
 * @since 1.0.0
 */
MediaType.images = 'image/gif, image/png, image/jpeg, image/webp, image/svg+xml';
/**
 * @property videos
 * @since 1.0.0
 */
MediaType.videos = 'video/ogg, video/mp4';
/**
 * @property audios
 * @since 1.0.0
 */
MediaType.audios = 'audio/ogg, audio/mpeg';
/**
 * @property files
 * @since 1.0.0
 */
MediaType.files = 'application/pdf';
/**
 * @enum MediaKind
 * @since 1.0.0
 */
export var MediaKind;
(function (MediaKind) {
    MediaKind[MediaKind["Image"] = 0] = "Image";
    MediaKind[MediaKind["Video"] = 1] = "Video";
    MediaKind[MediaKind["Audio"] = 2] = "Audio";
    MediaKind[MediaKind["Pdf"] = 3] = "Pdf";
})(MediaKind || (MediaKind = {}));
